// Slide decks associated with Software Engineering (SE) sprint 4

import { xyz_n_1of4_PAaA, xyz_n_1of4, xyz_n_2of4, xyz_n_3of4 } from './SL00000Sprint00TTR'

import { list44000Sprint03 } from '../ActivityLists/AL44000Sprint03'
import { list44000Sprint04 } from '../ActivityLists/AL44000Sprint04'

import { breakoutStandard,orderedListSlide, submissionPercentage } from './SLSprint00'
import { tNoClassToday } from './SL00000Sprint00'
import { insertInto, sprintPlanningSlideDeck } from './SLSprintPlanning'

const sprint = 4
const activityList = () => { return list44000Sprint04(sprint) }
const activityListPrevious = () => { return list44000Sprint03(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Session 1 of 4: Tuesday
const se_4_1of4 = () => {
	const sprintPlanningExpectations = () => {
		return orderedListSlide('Sprint Planning', `Sprint ${sprint} Expectations:`, [
			'Similar to other sprints with Discussion, Quiz, Lab, and Reflection',
			`Similar in that we will have two weeks to complete all sprint ${sprint} assignments`,
			'Different in that you will be performing sprint planning for your team’s sprint planning', 
			'Different in that sprint planning is mandatory in-person attendance for your sprint planning',
			'Different in that we have Fall Break** during the sprint',
			`Similar in that we will have sprint ${sprint-1} Demos and Retrospectives on Thursday`,
			`Similar in that we will complete on Discussion Board ${sprint} as a scrum team in class on Thursday` ])
	}

	const slideDeck =  xyz_n_1of4(null, null, sprintAndActivityLists, sprintPlanningExpectations)
	const recapSlide = 9
	const slideDeckWithPlanning =  insertInto(slideDeck, sprintPlanningSlideDeck(sprint), recapSlide)
	return slideDeckWithPlanning
}

// Session 2 of 4: Thursday
const se_4_2of4_PAaA = {
	'prework':[
		`Complete through activity 6 prior to next class`, '',
		'Complete Product Backlog Grooming',
		'Be prepared to compete Sprint 4 planning',
		'Be prepared for Demos and Retrospectives',
		`Be prepared for Discussion ${sprint} with your scrum team`,
	],
	'announcements':[
		'Sprint 4 Planning Due today!' ],
	'agenda':[
		`Sprint ${sprint} Planning (continued)`,
		`Sprint ${sprint-1} Demos`,
		`Sprint ${sprint-1} Retrospective`,
		`Breakout for Sprint ${sprint-1} Retrospective`,
		`Sprint ${sprint} Planning Q&A`,
		`Discussion Board ${sprint} as a scrum team`,
		'Prework for Next Class',
		'Lab' ],
	}

const se_4_2of4 = () => {
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Discussion', due:23, submitted:22 },
			{ name: 'Quiz', due:23, submitted:22 },
			{ name: 'Lab', due:23, submitted:21 },
			{ name: 'Reflection', due:23, submitted:21 }])
	}
	const retrospective = () => {
		return orderedListSlide('Class Retrospective',
			'Feedback from Assignments & Reflections', [
			`Okay submission percentage in sprint ${sprint-1}`,
			'Some Lab and Reflection assignments not graded/posted', 
			'Lots of nice comments about scrum teammates',
			`If you are not where you want to be in the class after sprint ${sprint-1}, we need to talk.`,
			`If you are not where you want to be in the class after sprint ${sprint}, you should consider dropping` ])
	}
	const slideDeck = xyz_n_2of4(se_4_2of4_PAaA, se_4_3of4_PAaA, sprintAndActivityLists, metricsSubmissionPercentage, retrospective)
	const agendaSlide = 4
	const slideDeckWithPlanning =  insertInto(slideDeck, sprintPlanningSlideDeck(sprint), agendaSlide)
	return slideDeckWithPlanning
}

// Session 3 of 4: Tuesday
const breakoutProductPresentations = 'Product Presentations by Capstone Teams'
const ProductPresentations = () => {
	return breakoutStandard( 
		`${breakoutProductPresentations} Breakout`, 
		`In this breakout session on “${breakoutProductPresentations}” your team will discuss:`, [
		'SyllaBye by CookieMonster with TheUltimateNullPointers',
		'ECaMS Billboard by StoneOcean with SpiderScrum',
		'PitHub by BearDown with RedDragons (or OverFlowers) **',
		'QuizMaster by TheNullPointers with OverFlowers (or RedDragons) **',
		'Stories by Bobby Didomenico with PurpleCobras',
		'Breakout and share Capstone Coach, Product Discord, and Software Engineering Scrum Master'
	])
}

const se_4_3of4_PAaA = {
	'prework':[ 
		'Submit Lab 4 - Planning by the end of the day Thursday last week', '',
		'Come prepared to work on “Health Insurance Risk Calculator for the Web As A Team”' ],
	'announcements':[ 
		'No class Thursday' ],
	'agenda':[ 
		`${breakoutProductPresentations}`,
		'Health Insurance Risk Calculator for the Web As A Team',
		'Prework for Next Class' ]
}
const se_4_3of4 = () => { return xyz_n_3of4(se_4_3of4_PAaA, se_4_4of4_PAaA, sprintAndActivityLists, ProductPresentations) } 

// Session 4 of 4: Thursday
const se_4_4of4_PAaA = xyz_n_1of4_PAaA(sprint+1)
const se_4_4of4 = () => { return [ tNoClassToday ] }

export const se_4_slidedeckTTR = [ se_4_1of4, se_4_2of4, se_4_3of4, se_4_4of4 ]